import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { registrarServiceWorker } from './lib/push.js';
import { acompanharTeclado } from './lib/teclado.js';
import './styles.css';

const container = document.getElementById('raiz');
if (!container) throw new Error('elemento raiz não encontrado');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// O service worker cuida dos avisos e de abrir rápido. Falha ao registrar não
// impede o painel de funcionar.
void registrarServiceWorker();

// Publica a altura real da tela numa variável CSS; sem isso o teclado do
// iPhone cobre a caixa de escrever.
acompanharTeclado();
